import {
  CustomMappingOption,
  ICustomMappingSourceOption,
  ITranslationMap,
} from '@principle-theorem/practice-migrations/interfaces';
import { AtLeast, IXSLXExport, XSLXCell } from '@principle-theorem/shared';
import { Column } from 'exceljs';

export interface IAppointmentBookToStatusXLSX {
  sourceId: string;
  sourceName: string;
  mapTo: string;
}

export const APPOINTMENT_BOOK_TO_STATUS_HEADERS: AtLeast<
  Column,
  'key' | 'header'
>[] = [
  {
    key: 'sourceId',
    header: 'Id',
  },
  {
    key: 'sourceName',
    header: 'Appointment Book',
    width: 45,
  },
  {
    key: 'mapTo',
    header: 'Map To',
    width: 30,
  },
];

export class AppointmentBookToStatusToXSLX
  implements
    IXSLXExport<ICustomMappingSourceOption, IAppointmentBookToStatusXLSX>
{
  headers = APPOINTMENT_BOOK_TO_STATUS_HEADERS;

  constructor(
    private _appointmentStatusOptions: CustomMappingOption[],
    private _existingMappings: ITranslationMap<object, string>[]
  ) {}

  translate(
    records: ICustomMappingSourceOption[]
  ): Record<keyof IAppointmentBookToStatusXLSX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existingMapping) => existingMapping.sourceIdentifier === record.value
      );

      const destinationIdentifier = existingRecord?.destinationValue;
      const mappedValue = destinationIdentifier
        ? this._appointmentStatusOptions.find(
            (option) => option.value === destinationIdentifier.value
          )
        : undefined;

      return {
        sourceId: {
          value: record.value,
        },
        sourceName: {
          value: record.label,
        },
        mapTo: {
          value: mappedValue?.description,
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._appointmentStatusOptions
                .map((option) => option.description)
                .join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
